(function () {
  function sanitizeEngravingText(value) {
    return (value || '').replace(/[^a-zA-Z0-9\sàèéìòóùäëïöü]/g, '').trim();
  }

  function getPreviewLineClass(preview) {
    return preview.classList.contains('minicart-engraving__preview')
      ? 'minicart-engraving__preview-line'
      : 'engraving__preview-line';
  }

  function ensureLineElements(preview) {
    var line1El = preview.querySelector('[data-engraving-preview-line="1"]');
    var line2El = preview.querySelector('[data-engraving-preview-line="2"]');

    if (!line1El) {
      preview.textContent = '';

      var lineClass = getPreviewLineClass(preview);

      line1El = document.createElement('span');
      line1El.className = lineClass;
      line1El.dataset.engravingPreviewLine = '1';

      line2El = document.createElement('span');
      line2El.className = lineClass;
      line2El.dataset.engravingPreviewLine = '2';

      preview.appendChild(line1El);
      preview.appendChild(line2El);
    }

    return { line1El: line1El, line2El: line2El };
  }

  function fitLine(lineEl) {
    var text = lineEl.textContent;

    lineEl.style.display = text ? 'block' : 'none';
    if (!text) return;

    lineEl.style.fontSize = '';

    var fontSize = parseFloat(getComputedStyle(lineEl).fontSize);
    var containerWidth = lineEl.parentElement.clientWidth;

    if (!containerWidth) return;

    while (lineEl.scrollWidth > containerWidth && fontSize > 4) {
      fontSize -= 0.5;
      lineEl.style.fontSize = fontSize + 'px';
    }
  }

  function bindInput(input, update) {
    if (!input || input.dataset.engravingCombinedBound === 'true') return;

    input.addEventListener('keypress', function (event) {
      if (!/^[a-zA-Z0-9\sàèéìòóùäëïöü]$/.test(event.key)) {
        event.preventDefault();
      }
    });

    input.addEventListener('input', function () {
      requestAnimationFrame(update);
    });

    input.addEventListener('paste', function (event) {
      event.preventDefault();
      var pasted = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])+/g, '');
      var start = input.selectionStart;
      var end = input.selectionEnd;

      input.value = input.value.slice(0, start) + pasted + input.value.slice(end);
      input.setSelectionRange(start + pasted.length, start + pasted.length);
      requestAnimationFrame(update);
    });

    input.dataset.engravingCombinedBound = 'true';
  }

  function initPreview(preview) {
    if (!preview || preview.dataset.combinedPreviewInit === 'true') return;

    var root = preview.closest('[data-minicart-engraving], .engraving__container, .engraving-inline-fields');
    if (!root) return;

    var line1Input = root.querySelector('[data-engraving-line="1"], #engravingTextFirstLine');
    var line2Input = root.querySelector('[data-engraving-line="2"], #engravingTextSecondLine');
    var lines = ensureLineElements(preview);

    function update() {
      lines.line1El.textContent = sanitizeEngravingText(line1Input && line1Input.value);
      lines.line2El.textContent = sanitizeEngravingText(line2Input && line2Input.value);
      fitLine(lines.line1El);
      fitLine(lines.line2El);
    }

    bindInput(line1Input, update);
    bindInput(line2Input, update);
    update();

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        requestAnimationFrame(update);
      });
      resizeObserver.observe(preview);
    }

    preview.dataset.combinedPreviewInit = 'true';
  }

  function initCombinedEngravingPreview(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('[data-engraving-preview-combined]').forEach(initPreview);
  }

  window.dAgency = window.dAgency || {};
  window.dAgency.initCombinedEngravingPreview = initCombinedEngravingPreview;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCombinedEngravingPreview();
    });
  } else {
    initCombinedEngravingPreview();
  }
})();
